module.exports = __webpack_public_path__ + "static/img/6.91745e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn1/6.jpg
// module id = 6Tfj
// module chunks = 0